export const STATUS_LABELS = {
  enforced: "Recorded as enforced",
  enforced_partial: "Partly protected",
  documented: "Written requirement",
  deferred: "Deferred",
  not_started: "Not started",
};
export const EVIDENCE_LABEL = "Not connected — test results are not available here yet";

export default function GuardianRuleCard({ rule, source }) {
  const revision = source.revision || "main";
  const sourceUrl = `https://github.com/jfm1-has/Jfm/blob/${revision}/${rule.source_path}`;
  return (
    <details className="guardian-rule">
      <summary>
        <span className="guardian-rule-title">{rule.title}</span>
        <code>{rule.id}</code>
        <span className="guardian-label">{STATUS_LABELS[rule.recorded_status]}</span>
      </summary>
      <div className="guardian-rule-body">
        {rule.explanation_state === "missing" && <p className="guardian-notice">Explanation missing</p>}
        {rule.applicability === "superseded" && <p className="guardian-notice">Superseded — see current rule</p>}
        {rule.applicability === "deferred" && <p className="guardian-notice">Future target — not current behavior</p>}
        {rule.applicability_note && <p>{rule.applicability_note}</p>}
        <dl>
          <dt>What it means</dt><dd>{rule.meaning}</dd>
          <dt>Why it matters</dt><dd>{rule.why_it_matters}</dd>
          <dt>Recommended next step</dt><dd>{rule.recommendation}</dd>
          <dt>Test evidence</dt><dd>{EVIDENCE_LABEL}</dd>
        </dl>
        <details className="guardian-evidence">
          <summary>View evidence details</summary>
          <p>A listed test is a reference, not a passed test. No last-checked version or time is available yet.</p>
          {rule.listed_tests.length ? (
            <ul>{rule.listed_tests.map((path, index) => <li key={`${index}-${path}`}><code>{path}</code></li>)}</ul>
          ) : <p>No test files are listed for this rule.</p>}
        </details>
        {!source.revision && <p>Source revision unavailable. The link opens the current rulebook on main.</p>}
        <a href={sourceUrl} target="_blank" rel="noopener noreferrer">Read official rulebook</a>
      </div>
    </details>
  );
}
